export default __webpack_public_path__ + "static/media/1363.606c9d5a.png";